export const COMPETITION_ID = "-NWlVTSqvUl8Kfi1RcUg";
